import styles from './CheckboxFilterSelector.module.scss'
import React from 'react'
import { FilterOption, TravelFilter, TravelFilterSelection } from '@/features/travelFilter/types'
import { Badge, Col, Form, Row } from 'react-bootstrap'
import FilterSelectorButtons from '@/components/models/travel/filter/TravelFilterNav/FilterSelectorButtons'
import { useTracking } from '@/integrations/tracking/useTracking'

const buildOptionColumns = (options: FilterOption[]) => {
  const numberOfColumns = 3
  const itemsPerColumn = Math.ceil(options.length / numberOfColumns)
  const columns = []
  for (let i = 0; i < numberOfColumns; i++) {
    columns.push(options.slice(i * itemsPerColumn, i * itemsPerColumn + itemsPerColumn))
  }
  return columns
}

interface Props {
  filter: TravelFilter
  selection: TravelFilterSelection
  setSelection: (selection: TravelFilterSelection) => void
  applySelection: () => void
}

const CheckboxFilterSelector = ({ filter, selection, setSelection, applySelection }: Props) => {
  const { send } = useTracking()
  const optionColumns = buildOptionColumns(filter.options)
  const getIsSelected = (value: number | string) => {
    return !!selection.filter((selectionValue) => {
      return selectionValue == value
    }).length
  }

  const handleChangeSelection = (value: number) => {
    const newSelection = [...selection]
    const index = newSelection.indexOf(value)
    const valueLabel = filter.options.find((option) => option.value === value)?.label
    if (index === -1) {
      // add
      newSelection.push(value)
      setSelection([...selection, value])
      send.genericEvent({
        category: 'travel_filter',
        object: 'filter_option',
        action: 'add',
        data: {
          filter_type_name: filter.name,
          filter_option_value: valueLabel,
        },
      })
    } else {
      // remove
      newSelection.splice(index, 1)
      send.genericEvent({
        category: 'travel_filter',
        object: 'filter_option',
        action: 'remove',
        data: {
          filter_type_name: filter.name,
          filter_option_value: valueLabel,
        },
      })
    }
    setSelection(newSelection)
  }

  const handleResetSelection = () => {
    setSelection([])
  }

  return (
    <>
      <Col xs={12}>
        <Row>
          {optionColumns.map((column, index: number) => {
            return (
              <Col md="6" lg="4" key={index}>
                {column.map((option, index: number) => {
                  const isSelected = getIsSelected(option.value as number)
                  const count = option.itemCount
                  return (
                    <Form.Check
                      key={index}
                      id={`${filter.name}-${option.value}`}
                      label={
                        <>
                          {option.label}
                          <Badge pill className={`${styles.itemCountBadge} ${!count && isSelected ? styles.warning : ''}`}>
                            {count}
                          </Badge>
                        </>
                      }
                      className={styles.checkbox}
                      type="checkbox"
                      checked={isSelected}
                      onChange={() => handleChangeSelection(option.value as number)}
                      disabled={!count && !isSelected}
                    />
                  )
                })}
              </Col>
            )
          })}
          {/*{filter.options.map((option, index: number) => {*/}
          {/*  const isSelected = getIsSelected(option.value as number)*/}
          {/*  const count = option.itemCount*/}
          {/*  return (*/}
          {/*    <Col md="6" lg="4" key={index}>*/}
          {/*      <Form.Check*/}
          {/*        id={`${filter.name}-${option.value}`}*/}
          {/*        label={*/}
          {/*          <>*/}
          {/*            {option.label}*/}
          {/*            <Badge pill className={`${styles.itemCountBadge} ${!count && isSelected ? styles.warning : ''}`}>*/}
          {/*              {count}*/}
          {/*            </Badge>*/}
          {/*          </>*/}
          {/*        }*/}
          {/*        className={styles.checkbox}*/}
          {/*        type="checkbox"*/}
          {/*        checked={isSelected}*/}
          {/*        onChange={() => handleChangeSelection(option.value as number)}*/}
          {/*        disabled={!count && !isSelected}*/}
          {/*      />*/}
          {/*    </Col>*/}
          {/*  )*/}
          {/*})}*/}
        </Row>
      </Col>
      <Col xs={12}>
        <FilterSelectorButtons handleReset={handleResetSelection} handleApply={applySelection} />
      </Col>
    </>
  )
}

export default CheckboxFilterSelector
